module.exports = __webpack_public_path__ + "img/dunaint6.7da8c2ea.png";